//import * as lib from '../lib/lib'
import $ from 'jquery';

const COLLAPSED_CLASS = 'collapsed'

class ContactBtn {
    constructor(element) {
        if (!element) return

        this.element = element

        this.iniCollapsedBtn()
      
    }  

    iniCollapsedBtn() {
        $(window).on("scroll",()=>{
            if($(window).width() <= 768){
                var scrollPos = $(document).scrollTop();
                if(scrollPos > 0)
                $(this.element).addClass(COLLAPSED_CLASS)
                else
                $(this.element).removeClass(COLLAPSED_CLASS)
            }         
        })
    }
}

export default ContactBtn
